// extracted by mini-css-extract-plugin
module.exports = {"root":"LimitedAccessBanner_root___0pKK","text":"LimitedAccessBanner_text__1BiLw","button":"LimitedAccessBanner_button__1qJ3u"};